import Vector from './../Support/Vector'

/**
 * Scene class
 *      - manages the visible scene
 */
export default class {
    constructor (element) {
        this._el = element

        this._width = this._el.offsetWidth
        this._height = this._el.offsetHeight
        this._el.setAttribute('width', this._width)
        this._el.setAttribute('height', this._height)
        this._scene = this._el.getContext('2d')
    }

    getWidth () {
        return this._width
    }

    getHeight () {
        return this._height
    }

    getCenter () {
        return new Vector(
            Math.floor(this.getWidth() / 2),
            Math.floor(this.getHeight() / 2),
        )
    }

    getRandomPosition () {
        return new Vector(
            Math.floor(Math.random() * this.getWidth()),
            Math.floor(Math.random() * this.getHeight()),
        )
    }

    getRandomBorderPosition () {
        let x, y

        switch (Math.floor(Math.random() * 4)) {
        case 0:
            x = 0
            break
        case 1:
            x = this.getWidth()
            break
        case 2:
            y = 0
            break
        case 3:
            y = this.getHeight()
            break
        }
        if (x) {
            y = Math.floor(Math.random() * this.getHeight())
        } else {
            x = Math.floor(Math.random() * this.getWidth())
        }
        return new Vector(x, y)
    }

    drawCirlce (x, y, radius, color = null) {
        if (color) this._scene.strokeStyle = color
        this._scene.beginPath()
        this._scene.arc(x, y, radius, 0, 2 * Math.PI)
        this._scene.stroke()

        return this
    }

    drawRectangle (x, y, width, height, color = null) {
        if (color) this._scene.strokeStyle = color
        this._scene.strokeRect(x - (width / 2), y - (height / 2), width, height)

        return this
    }

    writeText (text, x, y, color = null) {
        if (color) this._scene.fillStyle = color
        this._scene.font = '12px "courier new"'
        this._scene.textBaseline = 'middle'
        this._scene.textAlign = 'center'
        this._scene.fillText(text, x, y)

        return this
    }

    clear () {
        this._scene.clearRect(0, 0, this.getWidth(), this.getHeight())
        return this
    }
}
